import React from 'react';
import styled from 'styled-components';
import { useTranslate } from '@bynder/localization';
import { IconClear } from '@bynder/icons';
import { iconSizeSmall } from '../../../helpers/iconSizes';
import { useSearchMode } from '../SpotlightState';

interface Props {
	onClick: (event: React.MouseEvent) => void;
}
export function ClearButton({ onClick }: Props) {
	const { translate } = useTranslate();
	const { canUseSimilaritySearch } = useSearchMode();

	return (
		<StyledAnchor
			href="#"
			title={translate('generalClear')}
			onClick={(event: React.MouseEvent) => onClick(event)}
			moveToTheLeft={canUseSimilaritySearch}
			className="clear spotlightClear"
			data-testid="spotlightClearButton"
		>
			<IconClear size={iconSizeSmall} />
		</StyledAnchor>
	);
}

const StyledAnchor = styled.a<{ moveToTheLeft?: boolean }>`
	right: ${(props) => (props.moveToTheLeft ? '39px!important' : '0px')};
`;
